import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import Notice from 'view/notice';

const NoticePage = () => {
	return (
		<PageTemplate>
			<Notice /> 
		</PageTemplate>
	);
};

export default NoticePage;

 